import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance"; // import useCurrentInstance from "@/hooks/useCurrentInstance";

import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, onMounted, reactive, ref } from "vue";
export default defineComponent({
  name: "Paymoney",
  components: {
    Head: Head,
    Pagination: Pagination,
    Tabs: Tabs
  },
  setup: function setup() {
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return mydemocracy();

            case 2:
              _context.next = 4;
              return mydemocracys();

            case 4:
              _context.next = 6;
              return nums();

            case 6:
              _context.next = 8;
              return numss();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    var value1 = ref([]);
    var titlenum = ref("");
    var titlenums = ref("");
    var totalone = ref(0);

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var tableData = ref([{
      orgName: "",
      Month: ""
    }]);
    var tableDataTwo = ref([{
      orgName: "",
      Month: "",
      createTime: ""
    }]);
    var titleArr = ["待缴费", "已缴费"];
    var loading = ref(false);
    var totalNumTwo = ref(10);
    var totalNum = ref(10);
    var objs = reactive({
      partyfeeType: 1,
      pageIndex: 1,
      pageSize: 10,
      queryTime: ""
    });
    var objss = reactive({
      partyfeeType: 0,
      pageIndex: 1,
      pageSize: 10,
      queryTime: ""
    }); //党费列表

    function mydemocracy() {
      return _mydemocracy.apply(this, arguments);
    }

    function _mydemocracy() {
      _mydemocracy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tableData.value = [];
                _context2.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getPayables"](objss);

              case 3:
                res = _context2.sent;
                res.data.forEach(function (element) {
                  tableData.value.push({
                    orgName: element.orgName,
                    Month: element.year + "年" + element.month + "月党费:" + element.money
                  });
                });
                totalone.value = res.total;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _mydemocracy.apply(this, arguments);
    }

    function mydemocracys() {
      return _mydemocracys.apply(this, arguments);
    } //总费用


    function _mydemocracys() {
      _mydemocracys = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tableDataTwo.value = [];
                _context3.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getPayables"](objs);

              case 3:
                res = _context3.sent;
                res.data.forEach(function (element) {
                  tableDataTwo.value.push({
                    orgName: element.orgName,
                    Month: element.year + "年" + element.month + "月党费:" + element.money,
                    createTime: element.createTime
                  });
                });
                totalone.value = res.total;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _mydemocracys.apply(this, arguments);
    }

    function nums() {
      return _nums.apply(this, arguments);
    }

    function _nums() {
      _nums = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getPayableMoney"](objss);

              case 2:
                res = _context4.sent;
                titlenum.value = res.data;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _nums.apply(this, arguments);
    }

    function numss() {
      return _numss.apply(this, arguments);
    } //时间筛选


    function _numss() {
      _numss = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getPayableMoney"](objs);

              case 2:
                res = _context5.sent;
                titlenums.value = res.data;

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _numss.apply(this, arguments);
    }

    function getTime() {
      var date1 = "";
      var date2 = "";

      if (value1.value != null) {
        var searchTime = "".concat(value1.value[0].getFullYear(), "-").concat(value1.value[0].getMonth() + 1);
        var searchTime1 = "".concat(value1.value[1].getFullYear(), "-").concat(value1.value[1].getMonth() + 1);

        if (parseInt(searchTime.split("-")[1]) < 10) {
          date1 = searchTime.split("-")[0] + "-" + "0" + searchTime.split("-")[1];
        } else {
          date1 = searchTime;
        }

        if (parseInt(searchTime1.split("-")[1]) < 10) {
          date2 = searchTime1.split("-")[0] + "-" + "0" + searchTime1.split("-")[1];
        } else {
          date2 = searchTime1;
        }

        var searchTimes = date1 + " " + "-" + " " + date2;
        objss.queryTime = searchTimes;
        objs.queryTime = searchTimes;
        numss();
        nums();
        mydemocracys();
        mydemocracy();
      } else {
        objss.queryTime = "";
        objs.queryTime = "";
        numss();
        nums();
        mydemocracys();
        mydemocracy();
      }
    }

    function changPageTwo(val) {
      console.log(val);
    }

    function changPage(val) {
      console.log(val);
    }

    return {
      tableData: tableData,
      titleArr: titleArr,
      loading: loading,
      totalNumTwo: totalNumTwo,
      changPageTwo: changPageTwo,
      totalNum: totalNum,
      changPage: changPage,
      tableDataTwo: tableDataTwo,
      totalone: totalone,
      titlenum: titlenum,
      titlenums: titlenums,
      value1: value1,
      getTime: getTime
    };
  }
});